// extracted by mini-css-extract-plugin
export default {"logo":"Logo-module--logo--104e9","large":"Logo-module--large--6e3ec","high":"Logo-module--high--f49cd","small":"Logo-module--small--87929","tiny":"Logo-module--tiny--738be"};